import {Serializable} from './serializable.abstract';

export class SellUnitDefinitionDTO extends Serializable {
  label: string;
}

export class SellUnitDefinition extends SellUnitDefinitionDTO {
}
